import { render, staticRenderFns } from "./dbusiness_second.vue?vue&type=template&id=25118b65&scoped=true&"
import script from "./dbusiness_second.vue?vue&type=script&lang=js&"
export * from "./dbusiness_second.vue?vue&type=script&lang=js&"
import style0 from "./dbusiness_second.vue?vue&type=style&index=0&id=25118b65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25118b65",
  null
  
)

export default component.exports